import dayjs from 'dayjs';
import { i18n } from 'yxt-i18n/es';

export const friendlyDateBeforeFilter = time => {
  let friendlyDate = '';
  if (time === '' || time === undefined || time === null) {
    return friendlyDate;
  } else {
    time = dayjs(time).format('YYYY-MM-DD HH:mm:ss.SSS');
    time = time.split('.', 1)[0];
    time = time.replace(new RegExp(/(-)/g), '/');
  }
  let now = new Date(); // 当前时间对象
  let createDate = new Date(time.replace(/-/g, '/'));
  let todayBegining = new Date();
  todayBegining.setHours(0);
  todayBegining.setMinutes(0);
  todayBegining.setSeconds(0);
  todayBegining.setMilliseconds(0);
  // 去掉 js 时间戳后三位，与php 时间戳保持一致
  time = (now.getTime() - createDate.getTime()) / 1000; // parseInt((now.getTime() - createDate.getTime()) / 1000);
  let timeDays = (todayBegining.getTime() - createDate.getTime()) / 1000;
  // alert(time)

  // 存储转换值
  let s;
  if (time < 60 * 1) {
    // 一分钟内
    return i18n.t('pc_common_lbl_just');
  } else if (time < 60 * 60 && time >= 60 * 1) {
    // 超过十分钟少于1小时
    s = Math.floor(time / 60);
    return i18n.t('pc_common_lbl_n_minutebefore', [s]);
  } else if (time < 60 * 60 * 24 && time >= 60 * 60) {
    // 超过1小时少于24小时
    s = Math.floor(time / 60 / 60);
    return i18n.t('pc_commonl_lbl_n_hourbefore', [s]);
  } else if (timeDays >= 0 && timeDays < 60 * 60 * 24) {
    // 超过1天少于3天内
    // s = Math.floor(time / 60 / 60 / 24)
    let hours = (createDate.getHours() < 10 ? '0' : '') + createDate.getHours();
    let minutes =
      (createDate.getMinutes() < 10 ? '0' : '') + createDate.getMinutes();
    return i18n.t('pc_common_lbl_yesterday_n', [hours + ':' + minutes]);
  } else if (timeDays >= 60 * 60 * 24 && timeDays < 60 * 60 * 24 * 2) {
    let hours = (createDate.getHours() < 10 ? '0' : '') + createDate.getHours();
    let minutes =
      (createDate.getMinutes() < 10 ? '0' : '') + createDate.getMinutes();
    return i18n.t('pc_common_lbl_beforeYesterday_n', [hours + ':' + minutes]);
  } else {
    // 超过3天
    // var date = new Date(parseInt(date) * 1000)
    let year = createDate.getFullYear();
    let month =
      (createDate.getMonth() < 9 ? '0' : '') + (createDate.getMonth() + 1);
    let day = (createDate.getDate() < 10 ? '0' : '') + createDate.getDate();
    return year + '-' + month + '-' + day;
  }
};
// 获取文件扩展名
export const getFileExtension = fileName => {
  return fileName.indexOf('.') > -1
    ? `.${fileName
      .split('.')
      .pop()
      .toLowerCase()}`
    : '';
};
// 获取文件类型
export const getFileClass = (fileName, extension) => {
  extension = extension || getFileExtension(fileName);
  let fileClass = '';
  switch (extension) {
    case '.zip':
      fileClass = 'zip';
      break;
    case '.doc':
    case '.docx':
      fileClass = 'word';
      break;
    case '.xls':
    case '.xlsx':
    case '.xlsm':
      fileClass = 'excel';
      break;
    case '.pdf':
      fileClass = 'pdf';
      break;
    case '.txt':
      fileClass = 'txt';
      break;
    case '.ppt':
    case '.pptm':
    case '.pptx':
    case '.pot':
    case '.potm':
    case '.potx':
    case '.pps':
    case '.ppsx':
      fileClass = 'ppt';
      break;
    case '.png':
    case '.gif':
    case '.jpg':
    case '.bmp':
    case '.jpeg':
    case '.ico':
    case '.svg':
      fileClass = 'img';
      break;
    case '.rar':
    case '.iso':
      fileClass = 'course';
      break;
    case '.wmv':
    case '.swf':
    case '.flv':
    case '.mp4':
    case '.rmvb':
    case '.avi':
    case '.mpg':
    case '.mkv':
    case '.mov':
    case '.mts':
      fileClass = 'video';
      break;
    case '.wav':
    case '.wma':
    case '.m4a':
    case '.w4v':
    case '.mp3':
    case '.amr':
      fileClass = 'audio';
  }

  return fileClass;
};
